import { Component, OnInit, ElementRef, ViewChild, AfterContentChecked } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'c-i',
  templateUrl: './i.component.html',
  styleUrls: ['./i.component.scss']
})
export class IComponent implements OnInit, AfterContentChecked {

  private static cache = new Map();
  private name: string;

  @ViewChild('content', { static: true }) content: any;

  constructor(
    private http: HttpClient,
    private element: ElementRef
  ) {
  }

  ngOnInit() {
  }

  private loadSvg() {
    if (this.name && !IComponent.cache.has(this.name)) {
      this.http.get(`assets/icon/${this.name}.svg`, { responseType: 'text' })
        .subscribe((res: any) => {
          IComponent.cache.set(this.name, res); // Save on cache
          this.element.nativeElement.innerHTML = res;
        });
    } else if (this.name) {
      this.element.nativeElement.innerHTML = IComponent.cache.get(this.name);
    }
  }

  ngAfterContentChecked() {
    if (this.content && this.content.nativeElement && !this.name) {
      this.name = this.content.nativeElement.innerText;
      this.loadSvg();
    }
  }

}
